<template>
    <Toggle 
				:colorLinks='"#D4485A"'
				:colorRechts='"#00D9AD"' 
				:value="!isMuted"
				:toggleFn='btnClick'>

			<template #links>
				<MuteIcon :muted="true" />
				geluid uit
			</template>
			
			<template #rechts>
				<MuteIcon :muted="false" />
				geluid aan
			</template>
			</Toggle>
</template>

<script>

import { useStore } from 'vuex';
import { ref, onMounted, computed } from 'vue';
import Toggle from '@/components/toggle';

import MuteIcon from '@/components/icons/mute';

export default {
  components:{Toggle, MuteIcon},
  setup () {
    const store = useStore()

		function btnClick() {
			store.dispatch('toggleSound');
		}

    const ASSETS = ref(process.env.VUE_APP_ASSETS);

    return {
      ASSETS,
			isMuted: computed(() => store.getters.isMuted),
			btnClick
    }
  }
}
</script>


<style lang="scss">
</style>